var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('div',{staticClass:"spinner-container",staticStyle:{"margin":"auto"}},[_c('div',{attrs:{"id":"spinner"}}),_c('p',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.lang=='en' ? 'Generation in progress ...':'동영상 생성 중 ...')+_vm._s(_vm.percentage !== undefined ? ` ${_vm.percentage}%` : ''))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }